import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

import RescueFormPage from "./rescueFormPage";
import Detail from "./detail";
import NoMatch from "../no-match";
import Progress from "./Progress";
import RescueAddress from "./rescueAddress";
import UploadPictures from "./UploadImages";
import Guide from "./Guide";
import SdkDebug from "./sdkDebug";
import TrailerDestinationPage from "./trailerDestination";
import RescueStatusPage from "./rescueStatus";

export default function Rescue() {
  const { path } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route exact path={`${path}`}>
          <RescueFormPage></RescueFormPage>
        </Route>
        <Route exact path={`${path}/address`}>
          <RescueAddress></RescueAddress>
        </Route>
        <Route exact path={`${path}/trailer-destination`}>
          <TrailerDestinationPage></TrailerDestinationPage>
        </Route>
        <Route exact path={`${path}/status`}>
          <RescueStatusPage></RescueStatusPage>
        </Route>
        <Route exact path={`${path}/detail`}>
          <Detail></Detail>
        </Route>
        <Route exact path={`${path}/progress`}>
          <Progress />
        </Route>
        <Route exact path={`${path}/picture`}>
          <UploadPictures />
        </Route>
        <Route exact path={`${path}/guide`}>
          <Guide />
        </Route>
        <Route exact path={`${path}/sdk-debug`}>
          <SdkDebug />
        </Route>
        <Route>
          <NoMatch />
        </Route>
      </Switch>
    </>
  );
}
